import React, { FC, useEffect, useState } from 'react';
import { MenuViewer } from '../../ResultPage/MenuViewer';
import { MenuType } from 'components/MenuConst/DiagnoseMenu';

type Props = {
  playlist: MenuType;
};

export const MenuViewerForDiagnose: FC<Props> = ({ playlist }) => {
  const [menuKey, setMenuKey] = useState<number>(0);
  useEffect(() => {
    setMenuKey(0);
  }, [playlist]);

  return (
    <div style={{ textAlign: 'center', marginTop: '1px' }}>
      <span style={{ fontWeight: 'bold', fontSize: '12pt' }}>
        メニューの説明
      </span>
      <div style={{ margin: '10px 4px 20px 2px' }}>
        <MenuViewer
          menuList={playlist}
          menuKey={menuKey}
          setMenuKey={setMenuKey}
          width={0.94}
        />
      </div>
      <div
        style={{ margin: '-2px 0 10px 0', fontSize: '10pt', color: '#424242' }}
      >
        （青枠外をタップするとメニューの説明を閉じます）
      </div>
    </div>
  );
};
